export const isRelativeURL = (url: string): boolean => {
  return !(url.startsWith('http://') || url.startsWith('https://'));
};
